/// <amd-module name="Test/TestPlansHubRefresh/TestCasesImportModule/Constants" />
export const hideConfirmationDialogCookie: string = "HideConfirmationDialog";